module.exports = __webpack_public_path__ + "img/1.ca6e0a39.jpg";